<template>
  <main class="main inside-page form-page login-page">
    <div class="section login-section">
      <div class="left">
        <div class="left-wrapper">
          <router-link to="/" class="logo">
            <img class="img" src="../images/logo.svg" />
            <div class="title tiny">Elystr</div>
          </router-link>
          <div class="title">
            {{ $t("Welcome Back Stranger!") }}
          </div>
          <ValidationObserver ref="form" v-slot="{ handleSubmit }" slim>
            <form @submit.prevent="handleSubmit(submit)" class="form">
              <ValidationProvider
                mode="passive"
                slim
                v-slot="{ errors }"
                rules="required|email"
                vid="email"
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("E-mail") }}:</b>
                  </div>
                  <input
                    v-model="email"
                    required
                    name="email"
                    type="email"
                    :placeholder="$t('Enter you e-mail')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <ValidationProvider
                mode="passive"
                slim
                v-slot="{ errors }"
                rules="required"
                vid="password"
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("Password") }}:</b>
                  </div>
                  <input
                    v-model="password"
                    required
                    name="password"
                    type="password"
                    :placeholder="$t('Enter you рassword')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <div v-if="error" class="general-error">
                {{ error }}
              </div>

              <div class="link-container">
                <router-link to="/recover" class="desc link">
                  <b>{{ $t("Forgot your password?") }}</b>
                </router-link>
              </div>
              <div class="button-container">
                <button type="submit" class="button colored">
                  {{ $t("Continue") }}
                </button>
              </div>
              <div class="center-link-container">
                <div class="desc">{{ $t("Don't have an account?") }}</div>
                <router-link to="/register" class="desc link">
                  <b>{{ $t("Sign Up") }}</b>
                </router-link>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <div class="right"></div>
    </div>
  </main>
</template>

<script>
import axios from "@/axios";
import router from "@/router";
import { mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "Login",
  props: [],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: function () {
    return {
      email: "",
      password: "",
      error: "",
    };
  },
  mounted() {},
  methods: {
    submit() {
      const self = this;

      axios
        .post("login", {
          email: this.email,
          password: this.password,
        })
        .then(({ data }) => {
          if (data.status === "OK") {
            self.getProfile();
            router.push("/");
          } else if (data.status === "ERROR") {
            self.error = data.message;
          }
        })
        .catch(({ response }) => {
          if (response.status === 400) {
            if (response.data.message) {
              self.error = response.data.message;
            } else if (response.data.errors) {
              this.$refs.form.setErrors(response.data.errors);
            }
          }
        });
    },
    ...mapActions("user", ["getProfile"]),
  },
};
</script>
